import React from 'react'
import { makeStyles } from '@mui/styles'

import { getLabelForCountry } from '@/config'
import { customerTypes } from '@/modules/base/util/constants'
import { SquareIconButton } from '@/modules/base/components/buttons/index'
import IconEdit from '@assets/images/icons/pencil.svg'
import IconDelete from '@assets/images/icons/trashcan.svg'
import IconArrowRight from '@assets/images/icons/arrowRight.svg'
import lang from '@/lang'

const { COMPANY } = customerTypes

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    borderTop: `1px solid ${theme.borderColor}`,
    '& $actions': {
      display: 'flex',
    },
    '&:last-of-type': {
      borderBottom: `1px solid ${theme.borderColor}`,
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    overflowWrap: 'break-word',
    padding: '15px 0px',
    flex: '1 0 95%',
    maxWidth: '95%',
    height: '120px',
  },
  actions: {
    display: 'none',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    flex: '0 1 5%',
    '& button:first-child': {
      marginBottom: '8px',
    },
  },
}))

const AddressItem = (props) => {
  const classes = useStyles()
  const {
    data,
    onEditClick,
    onDeleteClick,
    onSelectClick,
  } = props
  const {
    kind,
    salutation,
    title,
    companyName,
    companyNameAffix,
    firstName,
    lastName,
    street,
    zipCode,
    city,
    countryIso,
  } = data

  const displayName = kind === COMPANY
    ? [companyName, companyNameAffix].join(' ')
    : [salutation, title, firstName, lastName].join(' ')
  const { label: country } = getLabelForCountry(countryIso)

  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <span>{displayName}</span>
        <span>{street}</span>
        <span>{`${zipCode} ${city}`}</span>
        <span>{country}</span>
      </div>
      <div className={classes.actions}>
        <SquareIconButton
          tooltip={lang.generics.edit}
          icon={IconEdit}
          iconColor='#fff'
          variant='primary'
          onClick={() => (onEditClick && onEditClick(data))}
        />
        { onDeleteClick && (
          <SquareIconButton
            tooltip={lang.generics.delete}
            icon={IconDelete}
            iconColor='#fff'
            variant='red'
            onClick={() => onDeleteClick(data)} />
        )
        }
        {
          onSelectClick && (
            <SquareIconButton
              tooltip={lang.generics.apply}
              icon={IconArrowRight}
              onClick={() => (onSelectClick && onSelectClick(data))} />
          )
        }
      </div>
    </div>
  )
}

export default AddressItem
